const translations = {
  title: 'Creando Formulario',
  title_edit: 'Editando Formulario',
  generalSectionTitle: 'Información básica',
  accessSectionTitle: 'Acceso',
  themeSectionTitle: 'Tema',
  themeLogo: 'Logo',
  themeColor: 'Color',
  redirectionSection: 'Redireccionamiento',
  redirectionLabel: 'Al responder, redirigir a ejecución',
  validationField: 'Campo de Validación',
  placeType: 'Tipo*',
  setupSection: 'Configuraciones de finalización',
  name: 'Nombre*',
  checklist: 'Cuestionario*',
  description: 'Descripción*',
  access: 'Acceso*',
  private: 'Privado',
  public: 'Público',
  conclusionTitle: 'Título del mensaje de conclusión',
  conclusionBody: 'Cuerpo del mensaje de conclusión'
}

export default translations
